function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import { utils as utils_exports, DEFAULTS, registerButton, AbstractButton, AbstractConfigurablePlugin, events as events_exports$1, TypedEvent } from '../core/index.module.js';
import { Vector3, Euler, Quaternion, Object3D, MathUtils } from '../../three/build/three.module.js';

/*!
 * PhotoSphereViewer.GyroscopePlugin 5.1.0
 * @copyright 2023 Damien "Mistic" Sorel
 * @licence MIT (https://opensource.org/licenses/MIT)
 */
var __defProp = Object.defineProperty;
var __export = function __export(target, all) {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};

// src/compass.svg
var compass_default = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><path fill="currentColor" d="M50 0a50 50 0 1 0 0 100A50 50 0 0 0 50 0zm0 88.81a38.86 38.86 0 0 1-38.81-38.8 38.86 38.86 0 0 1 38.8-38.82A38.86 38.86 0 0 1 88.82 50 38.87 38.87 0 0 1 50 88.81z"/><path fill="currentColor" d="M72.07 25.9L40.25 41.06 27.92 74.12l31.82-15.18v-.01l12.32-33.03zM57.84 54.4L44.9 42.58l21.1-10.06-8.17 21.9z"/><!--Created by iconoci from the Noun Project--></svg>';

// src/events.ts
var events_exports = {};
__export(events_exports, {
  GyroscopeUpdatedEvent: function GyroscopeUpdatedEvent() {
    return _GyroscopeUpdatedEvent2;
  }
});
var _GyroscopeUpdatedEvent = /*#__PURE__*/function (_TypedEvent) {
  _inherits(_GyroscopeUpdatedEvent, _TypedEvent);
  var _super = _createSuper(_GyroscopeUpdatedEvent);
  function _GyroscopeUpdatedEvent(gyroscopeEnabled) {
    var _this;
    _classCallCheck(this, _GyroscopeUpdatedEvent);
    _this = _super.call(this, _GyroscopeUpdatedEvent.type);
    _this.gyroscopeEnabled = gyroscopeEnabled;
    return _this;
  }
  return _createClass(_GyroscopeUpdatedEvent);
}(TypedEvent);
var _GyroscopeUpdatedEvent2 = _GyroscopeUpdatedEvent;
_GyroscopeUpdatedEvent2.type = "gyroscope-updated";

// src/GyroscopeButton.ts
var GyroscopeButton = /*#__PURE__*/function (_AbstractButton) {
  _inherits(GyroscopeButton, _AbstractButton);
  var _super2 = _createSuper(GyroscopeButton);
  function GyroscopeButton(navbar) {
    var _this2;
    _classCallCheck(this, GyroscopeButton);
    _this2 = _super2.call(this, navbar, {
      className: "psv-gyroscope-button",
      icon: compass_default,
      hoverScale: true,
      collapsable: true,
      tabbable: true
    });
    _this2.plugin = _this2.viewer.getPlugin("gyroscope");
    if (_this2.plugin) {
      _this2.plugin.addEventListener(_GyroscopeUpdatedEvent2.type, _assertThisInitialized(_this2));
    }
    return _this2;
  }
  _createClass(GyroscopeButton, [{
    key: "destroy",
    value: function destroy() {
      if (this.plugin) {
        this.plugin.removeEventListener(_GyroscopeUpdatedEvent2.type, this);
      }
      _get(_getPrototypeOf(GyroscopeButton.prototype), "destroy", this).call(this);
    }
  }, {
    key: "isSupported",
    value: function isSupported() {
      return !this.plugin ? false : {
        initial: false,
        promise: this.plugin.isSupported()
      };
    }
  }, {
    key: "handleEvent",
    value: function handleEvent(e) {
      if (e instanceof _GyroscopeUpdatedEvent2) {
        this.toggleActive(e.gyroscopeEnabled);
      }
    }
  }, {
    key: "onClick",
    value: function onClick() {
      this.plugin.toggle();
    }
  }]);
  return GyroscopeButton;
}(AbstractButton);
GyroscopeButton.id = "gyroscope";
var _zee = new Vector3(0, 0, 1);
var _euler = new Euler();
var _q0 = new Quaternion();
var _q1 = new Quaternion(-Math.sqrt(0.5), 0, 0, Math.sqrt(0.5));
var DeviceOrientationControls = /*#__PURE__*/_createClass(function DeviceOrientationControls(object) {
  _classCallCheck(this, DeviceOrientationControls);
  if (window.isSecureContext === false) {
    console.error("THREE.DeviceOrientationControls: DeviceOrientationEvent is only available in secure contexts (https)");
  }
  var scope = this;
  var EPS = 1e-6;
  var lastQuaternion = new Quaternion();
  this.object = object;
  this.object.rotation.reorder("YXZ");
  this.enabled = true;
  this.deviceOrientation = {};
  this.screenOrientation = 0;
  this.alphaOffset = 0;
  var onDeviceOrientationChangeEvent = function onDeviceOrientationChangeEvent(event) {
    scope.deviceOrientation = event;
  };
  var onScreenOrientationChangeEvent = function onScreenOrientationChangeEvent() {
    scope.screenOrientation = window.orientation || 0;
  };
  var setObjectQuaternion = function setObjectQuaternion(quaternion, alpha, beta, gamma, orient) {
    _euler.set(beta, alpha, -gamma, "YXZ");
    quaternion.setFromEuler(_euler);
    quaternion.multiply(_q1);
    quaternion.multiply(_q0.setFromAxisAngle(_zee, -orient));
  };
  this.connect = function () {
    onScreenOrientationChangeEvent();
    if (window.DeviceOrientationEvent !== void 0 && typeof window.DeviceOrientationEvent.requestPermission === "function") {
      window.DeviceOrientationEvent.requestPermission().then(function (response) {
        if (response == "granted") {
          window.addEventListener("orientationchange", onScreenOrientationChangeEvent);
          window.addEventListener("deviceorientation", onDeviceOrientationChangeEvent);
        }
      })["catch"](function (error) {
        console.error("THREE.DeviceOrientationControls: Unable to use DeviceOrientation API:", error);
      });
    } else {
      window.addEventListener("orientationchange", onScreenOrientationChangeEvent);
      window.addEventListener("deviceorientation", onDeviceOrientationChangeEvent);
    }
    scope.enabled = true;
  };
  this.disconnect = function () {
    window.removeEventListener("orientationchange", onScreenOrientationChangeEvent);
    window.removeEventListener("deviceorientation", onDeviceOrientationChangeEvent);
    scope.enabled = false;
  };
  this.update = function () {
    if (scope.enabled === false) return;
    var device = scope.deviceOrientation;
    if (device) {
      var alpha = device.alpha ? MathUtils.degToRad(device.alpha) + scope.alphaOffset : 0;
      var beta = device.beta ? MathUtils.degToRad(device.beta) : 0;
      var gamma = device.gamma ? MathUtils.degToRad(device.gamma) : 0;
      var orient = scope.screenOrientation ? MathUtils.degToRad(scope.screenOrientation) : 0;
      setObjectQuaternion(scope.object.quaternion, alpha, beta, gamma, orient);
      if (8 * (1 - lastQuaternion.dot(scope.object.quaternion)) > EPS) {
        lastQuaternion.copy(scope.object.quaternion);
      }
    }
  };
  this.dispose = function () {
    scope.disconnect();
  };
  this.connect();
});

// src/GyroscopePlugin.ts
var getConfig = utils_exports.getConfigParser({
  touchmove: true,
  absolutePosition: false,
  moveMode: "smooth"
}, {
  moveMode: function moveMode(_moveMode, _ref) {
    var defValue = _ref.defValue;
    if (_moveMode !== "smooth" && _moveMode !== "fast") {
      utils_exports.logWarn("GyroscopePlugin: invalid moveMode");
      return defValue;
    } else {
      return _moveMode;
    }
  }
});
var direction = new Vector3();
var GyroscopePlugin = /*#__PURE__*/function (_AbstractConfigurable) {
  _inherits(GyroscopePlugin, _AbstractConfigurable);
  var _super3 = _createSuper(GyroscopePlugin);
  function GyroscopePlugin(viewer, config) {
    var _this3;
    _classCallCheck(this, GyroscopePlugin);
    _this3 = _super3.call(this, viewer, config);
    _this3.state = {
      isSupported: _this3.__checkSupport(),
      alphaOffset: 0,
      enabled: false,
      config_moveInertia: true
    };
    return _this3;
  }
  _createClass(GyroscopePlugin, [{
    key: "init",
    value: function init() {
      _get(_getPrototypeOf(GyroscopePlugin.prototype), "init", this).call(this);
      this.viewer.addEventListener(events_exports$1.StopAllEvent.type, this);
      this.viewer.addEventListener(events_exports$1.BeforeRotateEvent.type, this);
      this.viewer.addEventListener(events_exports$1.BeforeRenderEvent.type, this);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.viewer.removeEventListener(events_exports$1.StopAllEvent.type, this);
      this.viewer.removeEventListener(events_exports$1.BeforeRotateEvent.type, this);
      this.viewer.removeEventListener(events_exports$1.BeforeRenderEvent.type, this);
      this.stop();
      delete this.controls;
      _get(_getPrototypeOf(GyroscopePlugin.prototype), "destroy", this).call(this);
    }
  }, {
    key: "handleEvent",
    value: function handleEvent(e) {
      if (e instanceof events_exports$1.StopAllEvent) {
        this.stop();
      } else if (e instanceof events_exports$1.BeforeRenderEvent) {
        this.__onBeforeRender();
      } else if (e instanceof events_exports$1.BeforeRotateEvent) {
        this.__onBeforeRotate(e);
      }
    }
  }, {
    key: "isSupported",
    value: function isSupported() {
      return this.state.isSupported;
    }
  }, {
    key: "isEnabled",
    value: function isEnabled() {
      return this.state.enabled;
    }
  }, {
    key: "start",
    value: function start() {
      var _this4 = this;
      return this.state.isSupported.then(function (supported) {
        if (supported) {
          return _this4.__requestPermission();
        } else {
          utils_exports.logWarn("gyroscope not available");
          return Promise.reject();
        }
      }).then(function (granted) {
        if (granted) {
          return Promise.resolve();
        } else {
          utils_exports.logWarn("gyroscope not allowed");
          return Promise.reject();
        }
      }).then(function () {
        _this4.viewer.stopAll();
        _this4.state.config_moveInertia = _this4.viewer.config.moveInertia;
        _this4.viewer.config.moveInertia = false;
        if (!_this4.controls) {
          _this4.controls = new DeviceOrientationControls(new Object3D());
        } else {
          _this4.controls.connect();
        }
        _this4.controls.deviceOrientation = null;
        _this4.controls.screenOrientation = 0;
        _this4.controls.alphaOffset = 0;
        _this4.state.alphaOffset = _this4.config.absolutePosition ? 0 : null;
        _this4.state.enabled = true;
        _this4.dispatchEvent(new _GyroscopeUpdatedEvent2(true));
      });
    }
  }, {
    key: "stop",
    value: function stop() {
      if (this.isEnabled()) {
        this.controls.disconnect();
        this.state.enabled = false;
        this.viewer.config.moveInertia = this.state.config_moveInertia;
        this.dispatchEvent(new _GyroscopeUpdatedEvent2(false));
        this.viewer.resetIdleTimer();
      }
    }
  }, {
    key: "toggle",
    value: function toggle() {
      if (this.isEnabled()) {
        this.stop();
      } else {
        this.start();
      }
    }
  }, {
    key: "__onBeforeRender",
    value: function __onBeforeRender() {
      if (!this.isEnabled()) {
        return;
      }
      if (!this.controls.deviceOrientation) {
        return;
      }
      var position = this.viewer.getPosition();
      if (this.state.alphaOffset === null) {
        this.controls.update();
        this.controls.object.getWorldDirection(direction);
        var sphericalCoords = this.viewer.dataHelper.vector3ToSphericalCoords(direction);
        this.state.alphaOffset = sphericalCoords.yaw - position.yaw;
      } else {
        this.controls.alphaOffset = this.state.alphaOffset;
        this.controls.update();
        this.controls.object.getWorldDirection(direction);
        var _sphericalCoords = this.viewer.dataHelper.vector3ToSphericalCoords(direction);
        var target = {
          yaw: _sphericalCoords.yaw,
          pitch: -_sphericalCoords.pitch
        };
        var step = this.config.moveMode === "smooth" ? 3 : 10;
        this.viewer.dynamics.position["goto"](target, utils_exports.getAngle(position, target) < 0.01 ? 1 : step);
      }
    }
  }, {
    key: "__onBeforeRotate",
    value: function __onBeforeRotate(e) {
      if (this.isEnabled()) {
        e.preventDefault();
        if (this.config.touchmove) {
          this.state.alphaOffset -= e.position.yaw - this.viewer.getPosition().pitch;
        }
      }
    }
  }, {
    key: "__checkSupport",
    value: function __checkSupport() {
      if ("DeviceOrientationEvent" in window && typeof DeviceOrientationEvent.requestPermission === "function") {
        return Promise.resolve(true);
      } else if ("DeviceOrientationEvent" in window) {
        return new Promise(function (resolve) {
          var listener = function listener(e) {
            resolve(e && e.alpha !== null && !isNaN(e.alpha));
            window.removeEventListener("deviceorientation", listener);
          };
          window.addEventListener("deviceorientation", listener, false);
          setTimeout(listener, 1e4);
        });
      } else {
        return Promise.resolve(false);
      }
    }
  }, {
    key: "__requestPermission",
    value: function __requestPermission() {
      if (typeof DeviceOrientationEvent.requestPermission === "function") {
        return DeviceOrientationEvent.requestPermission().then(function (response) {
          return response === "granted";
        })["catch"](function () {
          return false;
        });
      } else {
        return Promise.resolve(true);
      }
    }
  }]);
  return GyroscopePlugin;
}(AbstractConfigurablePlugin);
GyroscopePlugin.id = "gyroscope";
GyroscopePlugin.configParser = getConfig;

// src/index.ts
DEFAULTS.lang[GyroscopeButton.id] = "Gyroscope";
registerButton(GyroscopeButton, "caption:right");
export { GyroscopePlugin, events_exports as events };
//# sourceMappingURL=index.module.js.map
